
export default function SucessAlert(){
    return(
      <div className="w100 h100 b24 posifixedinicio column center z10">
        <h5 className="c1 fb">Sucesso!</h5>
        <h6 className="fb"></h6>
      </div>
    )
}